export enum ThemeName {
  LightTheme = "LightTheme",
}
